import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useQuery } from '@apollo/react-hooks';
import { SEARCH_HOTELS_AUTOCOMPLETE } from 'graphql/queries/getHotels';
import { GET_DESTINATIONS } from 'graphql/queries/destination';
import { HISTORY_HOTELS } from 'graphql/queries/getHotels';
import { Row, Form, Checkbox, Button } from 'antd';

import { CheckboxWrapper, DatePickerWrapper } from './MobileSearch.style';

import {
  Title,
  ContainerCustom,
  PureCard,
  RowCustom,
  DeviceBreakpoint,
  TitleLink,
  List,
  ListItem,
  Text,
  Span,
  Loader,
  LoaderScreenWrapper,
  Calendar,
  CalendarStyled,
  ColCustom,
} from 'components';
import { SearchAutoCompletePortalMobile } from './AutoComplete/AutoComplete/SearchAutoCompletePortalMobile';
import { SearchDropdownClickOutside } from './AutoComplete/DropdownClickOutside/SearchDropdownClickOutside';

import { Link, useHistory } from 'react-router-dom';
import moment from 'moment';
import { TitleMain } from '../../Main.styles';

import { LocationSVGRed, CalendarSVG, UserSVG } from 'lib/icons';
import { ReactComponent as ArrowLink } from 'assets/icons/arrowLink.svg';
import AlertSVG from 'assets/icons/Alert.svg';
import {
  AutoCompleteWrapper,
  SearchBar,
  RangePickerTransparent,
  BtnCounter,
  TitleSearchDrop,
  DatePickerContainer,
} from '../Header/SearchBarPanel.styles';

import SearchHeader from './SearchHeader';
import SearchFooter from './SearchFooter';
import ru from 'moment/locale/ru';
import en from 'moment/locale/en-gb';
const pluralize = require('numeralize-ru').pluralize;

// import { DatePickerContainer } from '../../../../components/Navbar/NavbarMobile.styles';

const rangeConfig = {
  rules: [
    {
      type: 'array',
      required: true,
      message: 'Please select time!',
    },
  ],
};

const MobileSearch = ({ setSearchVisibility }) => {
  const history = useHistory();
  const [currentStep, setStep] = useState(0);

  const intl = useIntl();

  const [guestNumber, setGuestNumber] = useState({
    adults: 2,
    children: 0,
    infants: 0,
  });

  React.useEffect(() => {
    console.log('ACTION guestNumber', guestNumber);
  }, [guestNumber]);

  const [searchInputValue, setSearchInputValue] = useState({
    region: {
      id: null,
      value: '',
    },
    checkinDate: '',
    checkoutDate: '',
    adults: guestNumber.adults,
    children: guestNumber.children,
    infants: guestNumber.infants,
    pets: false,
    isCalendarReset: false,
  });

  React.useEffect(() => {
    console.log('ACTION dataAutocomplete se ', searchInputValue);
  }, [searchInputValue]);

  const [searchResult, setSearchResult] = useState([]);

  const {
    loading: loadingAutocomplete,
    error: errorAutocomplete,
    data: dataAutocomplete,
  } = useQuery(SEARCH_HOTELS_AUTOCOMPLETE, {
    variables: {
      lang: `${localStorage.language ? localStorage.language : 'en'}`,
      searchString: searchInputValue.region.value,
    },
  });

  const { loading, error, data: destinations } = useQuery(GET_DESTINATIONS, {
    variables: {
      url: `${
        localStorage.language ? localStorage.language : 'en'
      }/destinations`,
    },
  });

  const {
    loading: loadingHistory,
    error: errorHistory,
    data: dataHistory,
  } = useQuery(HISTORY_HOTELS, {
    variables: {
      lang: history.location.pathname.slice(1),
      resultsNumber: 15,
    },
    fetchPolicy: 'network-only',
  });

  console.log(dataHistory);

  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const hideDatePicker = () => {
    setIsCalendarOpen(false);
  };

  const datePickerStatus = (status) => {
    if (!status) {
      hideDatePicker();
    }
  };

  const onSelectSearchAutocomplete = (id, title, slug) => {
    console.log('ACTION onSelectSearchAutocomplete: ', id, ' + ', title, slug);
    setSearchInputValue({
      ...searchInputValue,
      region: {
        id,
        value: title,
        slug,
      },
    });
    setStep((prevState) => (prevState += 1));
  };
  // Autocomplete method end

  const onChangeDate = (startDate, endDate) => {
    console.log('123', startDate, endDate);
    setSearchInputValue(() => ({
      ...searchInputValue,
      isCalendarReset: false,
    }));

    if (startDate && !endDate) {
      setSearchInputValue(() => ({
        ...searchInputValue,
        checkinDate: moment(startDate._d).format('YYYY-MM-DD'),
        checkoutDate: intl.formatMessage({
          id: 'search-panel.end-date',
        }),
        isCalendarReset: false,
      }));
    }

    if (startDate && endDate) {
      setSearchInputValue(() => ({
        ...searchInputValue,
        checkinDate: moment(startDate._d).format('YYYY-MM-DD'),
        checkoutDate: moment(endDate._d).format('YYYY-MM-DD'),
        isCalendarReset: false,
      }));
    }

    if (!startDate && !endDate) {
      setSearchInputValue({
        ...searchInputValue,
        checkinDate: null,
        checkoutDate: null,
      });
    }
  };

  const onDateReset = () => {
    setSearchInputValue({
      ...searchInputValue,
      checkinDate: null,
      checkoutDate: null,
      isCalendarReset: true,
    });
  };

  const onPetSelect = (e) => {
    console.log('### - With pet - ', e.target.checked);
    setSearchInputValue({
      ...searchInputValue,
      pets: e.target.checked,
    });
  };

  //   useEffect(() => {

  //     setDestinationResult(dataDestinations);
  //     console.log(destinationResult);
  //   }, [loadingDestinations, dataDestinations]);

  useEffect(() => {
    if (
      !loadingAutocomplete &&
      dataAutocomplete &&
      dataAutocomplete.regionList
    ) {
      console.log('dataAutocomplete: ', dataAutocomplete);
      console.log('dataAutocomplete er: ', errorAutocomplete);

      setSearchResult(
        dataAutocomplete.regionList.map(
          ({ region: { id, regionType, slug }, name, parents }) => ({
            id,
            slug,
            title: name,
            subtitle: parents,
            type: regionType.name,
            icon: regionType.icon,
          })
        )
      );
    }
  }, [loadingAutocomplete, dataAutocomplete]);

  const [isAlertShown, setIsAlertShown] = useState(false);

  const [redirect, setRedirect] = useState(false);

  // Autocomplete method start
  const onChangeSearchAutocomplete = (e) => {
    console.log('E: ', e.target.value);
    setIsAlertShown(false);
    setSearchInputValue({
      ...searchInputValue,
      region: {
        ...searchInputValue.region,
        value: e.target.value,
      },
    });
  };

  React.useEffect(() => {
    console.log('redirect: ', redirect);
  }, [redirect]);

  const onSubmitSearch = () => {
    const {
      region: { id: regionId, slug },
      checkinDate,
      checkoutDate,
    } = searchInputValue;

    const { adults, children, infants } = guestNumber;
    console.log('ACTION REGION', slug);
    if (!regionId) {
      setIsAlertShown(true);
    } else {
      // console.log('ACTION checkinDate', checkinDate);
      console.log(
        'ACTION searchInputValue',
        regionId,
        checkinDate,
        checkoutDate,
        adults,
        children,
        infants
      );

      const params = {
        checkinDate,
        checkoutDate,
        adults: adults === 0 ? 2 : adults,
        children,
        infants,
      };

      const urls = {
        checkinDate: `checkindate=${checkinDate}`,
        checkoutDate: `&checkoutdate=${checkoutDate}`,
        adults: `&adults=${adults === 0 ? 2 : adults}`,
        children: `&children=${children}`,
        infants: `&children=${infants}`,
      };

      let url = `/${localStorage.language}/search/${slug}?`;

      for (let prop in params) {
        if (params[prop]) {
          url += urls[prop];
        }
      }

      window.location.href = url;

      setRedirect(true);
    }
  };

  const getCurrentElement = () => {
    switch (currentStep) {
      case 0:
        return (
          <>
            <SearchBar
              width="100%"
              displayLaptop="block"
              style={{ position: 'relative' }}
            >
              <AutoCompleteWrapper
                width="368px"
                widthLaptop="100%"
                height="50px"
                marginLaptop="30px 0"
                backgroundColor="transparent"
                transform
              >
                <LocationSVGRed />
                <DeviceBreakpoint desktopHidden style={{ width: '85%' }}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <SearchAutoCompletePortalMobile
                      dropContLeft="-44vw"
                      placeholderColor="#353535"
                      bgInput="transparent"
                      dropContainerHeight="90vh"
                      dropWrapperWidth="100%"
                      dropContainerWidth="88vw"
                      placeholder={intl.formatMessage({
                        id: 'main-page.mobile-search.region',
                      })}
                      name="region"
                      value={searchInputValue.region.value}
                      options={[...searchResult]}
                      onChange={onChangeSearchAutocomplete}
                      onSelect={onSelectSearchAutocomplete}
                    />
                  </div>
                </DeviceBreakpoint>
              </AutoCompleteWrapper>
            </SearchBar>
          </>
        );
        break;
      case 1:
        return (
          <>
            <ColCustom
              margin="32px 0 32px 0"
              display="flex"
              justifyContent="space-between"
              align="flex-end"
            >
              <ColCustom display="flex" direction="column" align="flex-start">
                <Text sizeM="16px" sizeSm="16px" color="#353535" margin="0">
                  {intl.formatMessage({
                    id: 'search-panel.calendar-title',
                  })}
                </Text>
                <Text sizeM="14px" sizeSm="14px" color="#9791A7" margin="0">
                  {`${
                    searchInputValue.checkinDate
                      ? searchInputValue.checkinDate
                      : intl.formatMessage({
                          id: 'search-panel.start-date',
                        })
                  } - ${
                    searchInputValue.checkoutDate
                      ? searchInputValue.checkoutDate
                      : intl.formatMessage({
                          id: 'search-panel.end-date',
                        })
                  }`}
                </Text>
              </ColCustom>
              <ColCustom>
                <TitleLink size="14px" cursor="pointer" onClick={onDateReset}>
                  {intl.formatMessage({
                    id: 'search-panel.reset',
                  })}
                </TitleLink>
              </ColCustom>
            </ColCustom>
            <CalendarStyled
              onChangeDate={onChangeDate}
              isCalendarReset={searchInputValue.isCalendarReset}
            />
          </>
        );
      case 2:
        return (
          <>
            <Title size="16px" color="#353535" margin="32px 0 0 0">
              {intl.formatMessage({
                id: 'main-page.search-guests-number',
              })}
            </Title>
            <SearchBar
              margin="10px 0"
              marginSm="10px 0"
              width="100%"
              displayLaptop="block"
              style={{ position: 'relative' }}
              boxShadow="none"
            >
              <ContainerCustom bg="transparent" padding="25px 0" width="100%">
                <ContainerCustom display="flex" align="center">
                  <ContainerCustom display="flex" direction="column">
                    <Title size="16px" color="#353535" width="100px">
                      {' '}
                      {intl.formatMessage({
                        id: 'filters.adults-second',
                      })}
                    </Title>
                    <Text size="16px" margin="0" color="#9791A7">
                      13+{' '}
                      {intl.formatMessage({
                        id: 'main-page.search-age',
                      })}
                    </Text>
                  </ContainerCustom>
                  <BtnCounter
                    width="35px"
                    height="35px"
                    fontSize="20px"
                    margin="0 8px 0 auto"
                    onClick={() =>
                      setGuestNumber({
                        ...guestNumber,
                        adults:
                          guestNumber.adults - 1 < 0 ? 0 : --guestNumber.adults,
                      })
                    }
                  >
                    -
                  </BtnCounter>

                  <Title
                    width="30px"
                    center
                    display="flex"
                    align="center"
                    justify="center"
                  >
                    {guestNumber.adults}
                  </Title>
                  <BtnCounter
                    width="35px"
                    height="35px"
                    fontSize="20px"
                    onClick={() =>
                      setGuestNumber({
                        ...guestNumber,
                        adults: ++guestNumber.adults,
                      })
                    }
                  >
                    +
                  </BtnCounter>
                </ContainerCustom>
                <br />
                <ContainerCustom display="flex" align="center">
                  <ContainerCustom display="flex" direction="column">
                    <Title size="16px" color="#353535" width="100px">
                      {' '}
                      {intl.formatMessage({
                        id: 'main-page.search-kids',
                      })}
                    </Title>
                    <Text size="16px" margin="0" color="#9791A7">
                      2-12{' '}
                      {intl.formatMessage({
                        id: 'main-page.search-age',
                      })}
                    </Text>
                  </ContainerCustom>
                  <BtnCounter
                    width="35px"
                    height="35px"
                    fontSize="20px"
                    margin="0 8px 0 auto"
                    onClick={() =>
                      setGuestNumber({
                        ...guestNumber,
                        children:
                          guestNumber.children - 1 < 0
                            ? 0
                            : --guestNumber.children,
                      })
                    }
                  >
                    -
                  </BtnCounter>
                  <Title width="30px" center>
                    {guestNumber.children}
                  </Title>
                  <BtnCounter
                    width="35px"
                    height="35px"
                    fontSize="20px"
                    onClick={() =>
                      setGuestNumber({
                        ...guestNumber,
                        children: ++guestNumber.children,
                      })
                    }
                  >
                    +
                  </BtnCounter>
                </ContainerCustom>
                <br />
                <ContainerCustom display="flex" align="center">
                  <ContainerCustom display="flex" direction="column">
                    <Title size="16px" color="#353535" width="100px">
                      {' '}
                      {intl.formatMessage({
                        id: 'main-page.search-infants',
                      })}
                    </Title>
                    <Text size="16px" margin="0" color="#9791A7">
                      0-2{' '}
                      {intl.formatMessage({
                        id: 'main-page.search-age',
                      })}
                    </Text>
                  </ContainerCustom>
                  <BtnCounter
                    width="35px"
                    height="35px"
                    fontSize="20px"
                    margin="0 8px 0 auto"
                    onClick={() =>
                      setGuestNumber({
                        ...guestNumber,
                        infants:
                          guestNumber.infants - 1 < 0
                            ? 0
                            : --guestNumber.infants,
                      })
                    }
                  >
                    -
                  </BtnCounter>
                  <Title width="30px" center>
                    {guestNumber.infants}
                  </Title>
                  <BtnCounter
                    width="35px"
                    height="35px"
                    fontSize="20px"
                    onClick={() =>
                      setGuestNumber({
                        ...guestNumber,
                        infants: ++guestNumber.infants,
                      })
                    }
                  >
                    +
                  </BtnCounter>
                </ContainerCustom>

                <CheckboxWrapper>
                  <Checkbox
                    onChange={onPetSelect}
                    style={{ margin: '46px 0px' }}
                  >
                    <Title size="16px" color="#353535" margin="0 0 0 8px">
                      {intl.formatMessage({
                        id: 'main-page.search-travel-with-pet',
                      })}
                    </Title>
                  </Checkbox>
                </CheckboxWrapper>
              </ContainerCustom>
            </SearchBar>
          </>
        );
        break;
      default:
        break;
    }
  };

  const redirectOnMainPage = () => {
    setSearchInputValue({});
    setStep(0);
    setSearchVisibility(false);
  };

  const onBackClick = () => {
    if (currentStep === 0) {
      redirectOnMainPage();
    } else {
      setStep((prevState) => (prevState -= 1));
    }
  };

  const onForwarClick = () => {
    if (currentStep === 2) {
      onSubmitSearch();
    } else {
      setStep((prevState) => (prevState += 1));
    }
  };

  if (loading) {
    return (
      <LoaderScreenWrapper>
        <Loader />
      </LoaderScreenWrapper>
    );
  }

  if (localStorage.language === 'ru') {
    moment.locale('ru', ru);
  } else {
    moment.locale('en-gb', en);
  }

  return (
    <div>
      <SearchHeader
        region={currentStep > 0 ? searchInputValue.region.value : ''}
        date={
          currentStep > 1
            ? {
                checkinDate: searchInputValue.checkinDate,
                checkoutDate: searchInputValue.checkoutDate,
              }
            : null
        }
        onBackClick={onBackClick}
        redirectOnMainPage={redirectOnMainPage}
      />
      <ContainerCustom>{getCurrentElement()}</ContainerCustom>

      {currentStep === 0 &&
        !searchInputValue.region.value &&
        dataHistory &&
        dataHistory.searchHistory.length > 0 && (
          <>
            <TitleMain color="#9791A7" size="14px" margin="0 0 0 20px">
              {intl.formatMessage({
                id: 'main-page.resent-search',
              })}
            </TitleMain>

            <RowCustom direction="column" margin="19px 0 0 0">
              {dataHistory &&
                dataHistory.searchHistory
                  .slice(0, 4)
                  .map(
                    ({ id, checkinDate, checkoutDate, pax, region, url }) => (
                      <Link to={url}>
                        <PureCard
                          width="fit-content"
                          widthM="fit-content"
                          width1100="fit-content"
                          minwidth="200px"
                          align="flex-start"
                          // height="95px"
                          padding="10px 20px"
                          margin="0 25px 25px 0"
                          marginMobL="9px"
                          marginIconBottom="4px"
                          style={{
                            boxShadow: '0px 10px 50px rgba(0, 82, 180, 0.1)',
                          }}
                        >
                          <Title size="18px" size="14px" greyText margin="0  ">
                            <i className="fas fa-search icon-light" />
                            {region.name.length > 10
                              ? `${region.name.slice(0, 10)}...`
                              : region.name}
                          </Title>
                          <Title size="18px" size="14px" greyText>
                            {checkinDate &&
                              !checkoutDate &&
                              `${moment(checkinDate).format('DD MMMM, YYYY')}`}
                            {checkinDate &&
                              checkoutDate &&
                              `${moment(checkinDate).format(
                                'DD MMMM'
                              )} - ${moment(checkoutDate).format(
                                'DD MMMM, YYYY'
                              )}`}
                            {!checkinDate &&
                              !checkoutDate &&
                              intl.formatMessage({
                                id: 'main-page.time',
                              })}
                          </Title>
                          <Title size="18px" size="14px" greyText>
                            {localStorage.language === 'ru'
                              ? `${
                                  +guestNumber.adults + +guestNumber.children
                                } ${pluralize(
                                  +guestNumber.adults + +guestNumber.children,
                                  'Гость',
                                  'Гостя',
                                  'Гостей'
                                )}`
                              : `${
                                  +guestNumber.adults + +guestNumber.children
                                } ${
                                  +guestNumber.adults +
                                    +guestNumber.children ===
                                  1
                                    ? 'Guest'
                                    : 'Guests'
                                }`}
                          </Title>
                        </PureCard>
                      </Link>
                    )
                  )}
            </RowCustom>
          </>
        )}

      {currentStep === 0 &&
        !searchInputValue.region.value &&
        !dataHistory &&
        destinations &&
        destinations.destinationLinks && (
          <>
            <TitleMain margin="0 0 10px 0" color="#9791A7" size="14px">
              {intl.formatMessage({
                id: 'main-page.popular',
              })}
            </TitleMain>
            <List>
              {destinations.destinationLinks.map(({ anchor, subList, url }) => {
                // console.log('destination: ', destination);
                if (subList.length === 0) {
                  return null;
                } else {
                  return (
                    <ListItem margin="0 0 17px 0">
                      <TitleLink
                        to={`${url}`}
                        onClick={() => setSearchVisibility(false)}
                      >
                        <ContainerCustom display="flex" align="center">
                          {anchor}
                          <Span color="#353535" margin="0 20px 0 auto ">
                            {subList.length}
                          </Span>
                          <ArrowLink />
                        </ContainerCustom>
                      </TitleLink>
                    </ListItem>
                  );
                }
              })}
            </List>
          </>
        )}

      {currentStep > 0 ? (
        <SearchFooter
          currentStep={currentStep}
          onForwarClick={onForwarClick}
          onCancelClick={redirectOnMainPage}
        >
          {currentStep === 2
            ? intl.formatMessage({
                id: 'main-page.mobile-search',
              })
            : intl.formatMessage({
                id: 'main-page.forward',
              })}
        </SearchFooter>
      ) : null}
    </div>
  );
};

export default MobileSearch;
